import { render, staticRenderFns } from "./Zivildienstplaetze.vue?vue&type=template&id=36a9c7d7&"
import script from "./Zivildienstplaetze.vue?vue&type=script&lang=js&"
export * from "./Zivildienstplaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports